import { matchPath } from 'react-router-dom-v5'

export function getCampaignCodeFromPath() {
  const match = matchPath<{ code: string }>(window.location.pathname, {
    path: ['/merchant/:code', '/campaigns/:code', '/admin/:code'],
  })

  return match?.params.code
}
